<template>
  <main id="roomslider">
    <agile :arrows="false" :speed="750"
           :timing="'linear'" :fade="true"
           :autoplay="true" :pauseOnHover="false" v-bind:style="{height: myHeight/1.3 + 'px'}">
      <div class="slide slide--1" v-bind:style="{height: myHeight/1.3 + 'px'}"></div>
      <div class="slide slide--2" v-bind:style="{height: myHeight/1.3 + 'px'}"></div>
      <div class="slide slide--3" v-bind:style="{height: myHeight/1.3 + 'px'}"></div>
      <div class="slide slide--4" v-bind:style="{height: myHeight/1.3 + 'px'}"></div>
      <div class="slide slide--5" v-bind:style="{height: myHeight/1.3 + 'px'}"></div>
      <div class="slide slide--6" v-bind:style="{height: myHeight/1.3 + 'px'}"></div>
    </agile>
  </main>
</template>

<script>
export default {
  name: 'RoomSlider',
  data () {
    return {
      pageHeight: 1000,
      scrittaCarousel: 800,
      myHeight: window.innerHeight
    }
  },
  i18n: {
    fallbackLocale: 'it', // default lang,
    messages: {
      it: {
      },
      en: {
      }
    }
  },
  updated: function () {
    window.addEventListener('resize', this.getPageHeight)
  },
  mounted: function () {
    window.addEventListener('resize', this.getPageHeight)
    this.getPageHeight()
  },
  methods: {
    getPageHeight: function (event) {
      this.pageHeight = window.innerHeight
      this.scrittaCarousel = this.pageHeight - 150
    }
  }
}
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #roomslider{
    z-index: 1;
    .agile {
      .agile__track{
      }
      .agile__dots {
        bottom: 0px;
        left: 43%;
        position: absolute;
        width: 30px;
        .agile__dot {
          padding: 5px;
          margin-bottom: 10px;
          button {
            background-color: transparent;
            border: 1px solid #fff;
            margin-top: 10px;
            &:hover {
              background-color: #fff;
            }
          }

          &.agile__dot--current {
            button {
              background-color: #fff;
            }
          }
        }
      }
    }
    .slide {
      background-position: center;
      background-size: cover;
      height: 500px;
      &.slide--1 {
        background-image: url("../../static/image/rooms/1.jpg");
      }
      &.slide--2 {
        background-image: url("../../static/image/rooms/2.jpg");
      }
      &.slide--3 {
        background-image: url("../../static/image/rooms/4.jpg");
      }
      &.slide--4 {
        background-image: url("../../static/image/rooms/5.jpg");
      }
      &.slide--5 {
        background-image: url("../../static/image/rooms/6.jpg");
      }
      &.slide--6 {
        background-image: url("../../static/image/rooms/7.jpg");
      }
    }
  }

  @media (max-width: 767px) {
    #roomslider{
      .agile {
        .agile__dots {
          left: 8%;
        }
        .agile__dot {
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RoomSlider.vue